'use client'

import AutoWidget from '@components/common/AutoWidget/autoWidget'
import { getR2d2CommonProperties } from '@utils/r2d2Payload'
import { useSearchParams } from 'next/navigation'
import { Suspense, useEffect, useState } from 'react'
import { AutoProduct, type AutoWidgetVariant } from 'src/enums/AutoProduct'
import { type BannerIconPosition } from 'src/enums/NewFlowBanner'
import { getPageType } from 'src/helpers/commonHelpers'
import styles from './carWidget.module.scss'

interface newFlowBannerProps {
  heading?: string
  subHeading?: string
  ctaText?: string
  iconSrc?: string
  iconAlt?: string
  iconPosition: BannerIconPosition
}

type RegexPattern = string

interface CarWidgetProps {
  widgetHeading: string
  disclaimer?: string
  inputPlaceholder?: string
  widgetCtaText?: string
  segmentEventCommonProperties?: object
  newFlowBanner: newFlowBannerProps
  isSemPage: boolean
  isBottomFloater?: boolean
  widgetVariant?: AutoWidgetVariant
  isOldLayout?: boolean
  regexPatternsData?: RegexPattern[]
}

const CarWidgetImp = ({
  widgetHeading,
  disclaimer,
  inputPlaceholder,
  widgetCtaText,
  segmentEventCommonProperties,
  newFlowBanner,
  isSemPage,
  isOldLayout,
  isBottomFloater,
  widgetVariant,
  regexPatternsData,
}: CarWidgetProps) => {
  const searchParams =
    useSearchParams() || new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '')
  const queryString = new URLSearchParams(Object.fromEntries(searchParams)).toString()

  const newCarRedirectionUrl = `/new-car/car-type?utm_source=organic&utm_medium=seo&utm_campaign=product-widget&lpSource=/n${queryString}`
  const [r2d2CommonProperties, setR2d2CommonProperties] = useState({})
  useEffect(() => {
    const r2d2Props = getR2d2CommonProperties()
    setR2d2CommonProperties(r2d2Props)
  }, [])

  return (
    <div className={styles.carWidgetRootContainer}>
      <AutoWidget
        widgetHeading={widgetHeading}
        disclaimer={disclaimer}
        inputPlaceholder={inputPlaceholder}
        widgetCtaText={widgetCtaText || 'Get quote'}
        segmentEventCommonProperties={segmentEventCommonProperties}
        newFlowBanner={newFlowBanner}
        widgetType={getPageType(isSemPage)}
        product={AutoProduct.Car}
        newFlowRedirectionUrl={newCarRedirectionUrl}
        widgetVariant={widgetVariant}
        isBottomFloater={isBottomFloater}
        isSemPage={isSemPage}
        isOldLayout={isOldLayout}
        r2d2Commonproperties={r2d2CommonProperties}
        regexPatternsData={regexPatternsData}
      />
    </div>
  )
}

const CarWidget = props => (
  <Suspense>
    <CarWidgetImp {...props} />
  </Suspense>
)
export default CarWidget
